// RightSidebar.tsx
import { Button, Icon } from "@blueprintjs/core";
import { useState } from "react";
import OpenAiChat from "./OpenAiChat";

const NAVBAR_HEIGHT = 50;
const SUBHEADER_HEIGHT = 60;
const FOOTER_HEIGHT = 40;
const RAIL_WIDTH = 60;

export default function RightSidebar() {
  const [open, setOpen] = useState(false);
  const [resetKey, setResetKey] = useState(0);

  const close = () => {
    setOpen(false);
    setResetKey((k) => k + 1);
  };

  return (
    <>
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "1rem 0",
          boxSizing: "border-box",
        }}
      >
        <Button
          icon={<Icon icon="chat" color="#fff" />}
          large
          style={{
            width: 40,
            height: 40,
            backgroundColor: "#106ba3",
            borderColor: "#106ba3",
            color: "#fff",
            marginBottom: "0.5rem",
          }}
          onClick={() => setOpen(true)}
        />
        <Button
          icon={<Icon icon="help" color="#fff" />}
          large
          style={{
            width: 40,
            height: 40,
            backgroundColor: "#FF4F00",
            borderColor: "#FF4F00",
            color: "#fff",
          }}
          onClick={() =>
            (window.location.href =
              "mailto:support@endeavor-elements.com?subject=Support%20Request%20(source:%20ciq)")}
        />
      </div>
      {open && (
        <div
          style={{
            position: "fixed",
            top: NAVBAR_HEIGHT + SUBHEADER_HEIGHT,
            bottom: FOOTER_HEIGHT,
            right: RAIL_WIDTH,
            width: 320,
            background: "#fff",
            borderLeft: "1px solid #d8e1e8",
            boxShadow: "-2px 0 4px rgba(0,0,0,0.1)",
            zIndex: 2000,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              position: "relative",
              padding: "0.25rem 0.5rem",
              borderBottom: "1px solid #d8e1e8",
            }}
          >
            <Button
              minimal
              icon="cross"
              onClick={close}
              style={{ position: "absolute", right: 0, top: 0 }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <OpenAiChat key={resetKey} compact />
          </div>
        </div>
      )}
    </>
  );
}
